import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTransposeMatrixNoBackground = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 15" {...props}>
    <path
      fill="#7200B3"
      d="M6.254 3.345V.332h6.667q.574 0 .96.385.386.386.386.961v1.667zM2.28 13.665q-.576 0-.961-.385a1.3 1.3 0 0 1-.386-.96V5.651h3.013v8.013zM.933 3.345V1.678q0-.575.386-.96.386-.386.96-.386h1.667v3.013zm7.084 11.154L5.26 11.742l2.757-2.756.59.59-1.74 1.75h2.977q.863 0 1.473-.61t.61-1.474V6.255l-1.75 1.75-.59-.59 2.757-2.756L15.1 7.415l-.59.59-1.75-1.75v2.987q0 1.215-.85 2.066a2.81 2.81 0 0 1-2.066.85H6.866l1.74 1.75z"
    />
  </svg>
);
export default SvgTransposeMatrixNoBackground;
